<dialog class="agenda" #dialogo aria-labelledby="agenda-titulo">
  <div class="agenda-topo">
    <div>
      <h2 class="agenda-titulo" id="agenda-titulo">Agendar data e hora</h2>
      <p class="agenda-subtitulo">
        Escolha o dia do atendimento e depois um dos horários disponíveis.
      </p>
    </div>

    <button type="button" class="agenda-fechar" aria-label="Fechar" (click)="fechar()">
      <i-lucide name="x" size="20" aria-hidden="true"></i-lucide>
    </button>
  </div>

  <div class="agenda-corpo">
    <section class="agenda-bloco" aria-labelledby="agenda-calendario-titulo">
      <h3 class="agenda-bloco-titulo" id="agenda-calendario-titulo">
        <i-lucide name="calendar" size="18" aria-hidden="true"></i-lucide>
        Selecione a data
      </h3>

      <div class="agenda-navegacao">
        <button type="button" class="agenda-seta" aria-label="Mês anterior" [disabled]="!podeVoltarMes()" (click)="mesAnterior()">
          <i-lucide name="chevron-left" size="18" aria-hidden="true"></i-lucide>
        </button>

        <span class="agenda-mes" aria-live="polite">{{ rotuloMes() }}</span>

        <button type="button" class="agenda-seta" aria-label="Próximo mês" [disabled]="!podeAvancarMes()" (click)="proximoMes()">
          <i-lucide name="chevron-right" size="18" aria-hidden="true"></i-lucide>
        </button>
      </div>

      <div class="agenda-semana" aria-hidden="true">
        @for (dia of diasSemana; track $index) {
          <span>{{ dia }}</span>
        }
      </div>

      @if (carregando()) {
        <p class="agenda-estado" role="status" aria-live="polite">
          <i-lucide name="loader-circle" size="16" aria-hidden="true"></i-lucide>
          Carregando os horários disponíveis...
        </p>
      } @else if (falhou()) {
        <div class="agenda-estado agenda-estado-falha" role="alert">
          <i-lucide name="circle-alert" size="16" aria-hidden="true"></i-lucide>
          <span>Não foi possível carregar a agenda.</span>
          <button type="button" class="agenda-estado-botao" (click)="recarregar()">Tentar novamente</button>
        </div>
      } @else if (mesSemHorarios()) {
        <p class="agenda-estado" role="status">
          <i-lucide name="calendar-x" size="16" aria-hidden="true"></i-lucide>
          Não há horários disponíveis neste mês.
        </p>
      }

      <div class="agenda-grade">
        @for (dia of diasDoMes(); track dia.iso) {
          @if (dia.dia === null) {
            <span class="agenda-dia-vazio"></span>
          } @else {
            <button
              type="button"
              class="agenda-dia"
              [class.agenda-dia-hoje]="dia.hoje"
              [class.agenda-dia-selecionado]="dia.iso === dataSelecionada()"
              [disabled]="dia.indisponivel"
              [attr.aria-pressed]="dia.iso === dataSelecionada()"
              (click)="selecionarDia(dia)"
            >
              {{ dia.dia }}
            </button>
          }
        }
      </div>
    </section>

    <section class="agenda-bloco" aria-labelledby="agenda-horarios-titulo">
      <h3 class="agenda-bloco-titulo" id="agenda-horarios-titulo">
        <i-lucide name="clock" size="18" aria-hidden="true"></i-lucide>
        Selecione um horário
      </h3>

      @if (dataSelecionada()) {
        <div class="agenda-horarios">
          @for (horario of horariosDoDia(); track horario) {
            <button
              type="button"
              class="agenda-horario"
              [class.agenda-horario-selecionado]="horario === horarioSelecionado()"
              [attr.aria-pressed]="horario === horarioSelecionado()"
              (click)="selecionarHorario(horario)"
            >
              {{ horario }}
            </button>
          }
        </div>
      } @else {
        <p class="agenda-vazio">
          <i-lucide name="calendar-search" size="18" aria-hidden="true"></i-lucide>
          Escolha uma data no calendário para ver os horários disponíveis.
        </p>
      }
    </section>
  </div>

  <div class="agenda-rodape">
    @if (podeConfirmar()) {
      <p class="agenda-resumo" role="status">
        <i-lucide name="circle-check" size="16" aria-hidden="true"></i-lucide>
        {{ dataFormatada() }} às {{ horarioSelecionado() }}
      </p>
    } @else {
      <p class="agenda-resumo agenda-resumo-pendente" role="status">
        Selecione a data e o horário para confirmar.
      </p>
    }

    <div class="agenda-acoes">
      <button type="button" class="agenda-botao" (click)="fechar()">Cancelar</button>

      <button
        type="button"
        class="agenda-botao agenda-botao-primario"
        [disabled]="!podeConfirmar()"
        (click)="confirmar()"
      >
        <i-lucide name="check" size="16" aria-hidden="true"></i-lucide>
        Confirmar agendamento
      </button>
    </div>
  </div>
</dialog>
